import React from "react";
import "./HostEvents.css";

const HostEvents = ({
  label = "How it works",
  title = "Create, plan, manage, send invites  for your parties effortlessly.",
  description = "Plan and manage your events effortlessly. Send invites, collect Event attire payments, and track guest invites all from one platform with NimbleBash.",
  steps = [
    {
      description:
        "Create your event by adding your event title, date, location, and Aso Ebi price. You’re ready to go live..",
      image: "/images/create_event.png",
      badge: "Create & Customize Your Event",
    },
    {
      description:
        "Send digital invitations via WhatsApp, SMS, or email. Guest can click the link or use the invite code.",
      image: "/images/share_link.png",
      badge: "Invite Your Guests",
    },
    {
      description:
        "Secure payments for event attire, tickets, and cash gift. Automatic confirmations included.",
      image: "/images/ticket_image.png",
      badge: "Collect Contributions & Gifts",
    },
  ],
  largePhoneImage = "/images/event_management_iphone.png",
  paystackLogo = "/images/paystack.png",
}) => {
  return (
    <section className="host_events_section">
      <div className="host_events_container">
        {/* Left Content Area */}
        <div className="host_events_content">
          {/* Label */}
          <h3 className="host_events_label">{label}</h3>

          {/* Title */}
          <h2 className="host_events_title">{title}</h2>

          {/* Description */}
          <p className="host_events_description">{description}</p>

          {/* Step Cards Layout - Top Row (2 cards side by side) */}
          <div className="host_events_top_row">
            {/* Card 1 - Create & Customize Your Event */}
            <div className="host_events_step_card">
              <div className="host_events_card_badge">{steps[0].badge}</div>
              <div className="host_events_card_image_wrapper">
                <img
                  src={steps[0].image}
                  alt={steps[0].badge}
                  className="host_events_card_image"
                />
              </div>
              <p className="host_events_card_description">
                {steps[0].description}
              </p>
            </div>

            {/* Card 2 - Invite Your Guests */}
            <div className="host_events_step_card">
              <div className="host_events_card_badge">{steps[1].badge}</div>
              <div className="host_events_card_image_wrapper">
                <img
                  src={steps[1].image}
                  alt={steps[1].badge}
                  className="host_events_card_image"
                />
              </div>
              <p className="host_events_card_description">
                {steps[1].description}
              </p>
            </div>
          </div>

          {/* Card 3 - Collect Contributions & Gifts (Full Width with Overlapping Paystack) */}
          <div className="host_events_bottom_section">
            <div className="host_events_step_card host_events_full_width_card">
              <div className="host_events_card_badge">{steps[2].badge}</div>
              <div className="host_events_card_image_wrapper2">
                <p className="host_events_card_description1">
                  {steps[2].description}
                </p>
                <div className="host_events_card_image_wrapper1">
                  <img
                    src={steps[2].image}
                    alt={steps[2].badge}
                    className="host_events_card_image_lagre"
                  />
                </div>
              </div>
            </div>

            {/* Overlapping Paystack Card */}
            <div className="host_events_paystack_card">
              <img
                src={paystackLogo}
                alt="Paystack"
                className="host_events_paystack_logo"
              />
              <span className="host_events_payment_text">
                Trusted & Reliable Payment Gateway
              </span>
            </div>
          </div>
        </div>

        {/* Right Visual Area - Large Phone (Desktop/Tablet Only) */}
        <div className="host_events_visual">
          <img
            src={largePhoneImage}
            alt="Host Events Interface"
            className="host_events_large_phone"
          />
        </div>
      </div>
    </section>
  );
};

export default HostEvents;
